/* eslint-disable */ import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain';
export const createAdminPresets = createPresetsFactory();
export const generatedAdminPresets = createAdminPresets([
    {
        rootEntityType: 'Admin',
        initialDomainEntities: [
            {
                id: 'Admin-1',
                type: 'Admin',
                commonAdminModelVersion: 5
            }
        ]
    }
]);

//# sourceMappingURL=admin-presets.js.map